{
  "RESET_PASSWORD": {
    "TITLE": "പാസ്‌വേഡ് പുനഃസജ്ജമാക്കുക",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "ഇമെയിൽ",
      "PLACEHOLDER": "ദയവായി നിങ്ങളുടെ ഇമെയിൽ നൽകുക.",
      "ERROR": "ദയവായി സാധുവായ ഒരു ഇമെയിൽ നൽകുക."
    },
    "API": {
      "SUCCESS_MESSAGE": "Password reset link has been sent to your email.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "SUBMIT": "സമർപ്പിക്കുക"
  }
}
